import { ApiProperty } from '@nestjs/swagger';

export class CityTranslationViewModel {
  @ApiProperty()
  name: string;

  @ApiProperty()
  regionName?: string;

  @ApiProperty()
  namePrepositional: string;
}
